<template>
  <div class="page-container">
    <div style="margin-bottom:16px;">
      <div style="font-size:16px;font-weight:600;color:var(--text-primary);">广告配置</div>
      <div style="font-size:12px;color:var(--text-muted);margin-top:4px;">平台广告位配置与投放管理</div>
    </div>

    <!-- 搜索条件 -->
    <div class="table-wrapper" style="margin-bottom:16px;padding:16px;">
      <div style="display:flex;gap:12px;align-items:flex-end;flex-wrap:wrap;">
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">语言</label>
          <el-select v-model="search.lang" placeholder="全部" clearable size="small" style="width:130px;" @change="fetchList()">
            <el-option label="简体中文" value="zh_CN"></el-option>
            <el-option label="繁体中文" value="zh_TW"></el-option>
            <el-option label="English" value="en_US"></el-option>
          </el-select>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">广告名称</label>
          <el-input v-model="search.name" placeholder="请输入广告名称" clearable size="small" style="width:160px;"></el-input>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">广告类型</label>
          <el-select v-model="search.type" placeholder="全部" clearable size="small" style="width:140px;" @change="fetchList()">
            <el-option v-for="t in AD_TYPE_OPTIONS" :key="t.value" :label="t.label" :value="t.value"></el-option>
          </el-select>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">显示平台</label>
          <el-select v-model="search.platform" placeholder="全部" clearable size="small" style="width:120px;" @change="fetchList()">
            <el-option v-for="p in AD_PLATFORMS" :key="p.value" :label="p.label" :value="p.value"></el-option>
          </el-select>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">广告页面</label>
          <el-select v-model="search.position" placeholder="全部" clearable filterable size="small" style="width:140px;" @change="fetchList()">
            <el-option v-for="p in AD_POSITIONS" :key="p.code" :label="p.label" :value="p.code"></el-option>
          </el-select>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">广告对象</label>
          <el-select v-model="search.targetType" placeholder="不限" clearable size="small" style="width:120px;" @change="fetchList()">
            <el-option v-for="t in AD_TARGET_TYPES" :key="t.value" :label="t.label" :value="t.value"></el-option>
          </el-select>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">审核状态</label>
          <el-select v-model="search.status" placeholder="全部" clearable size="small" style="width:110px;" @change="syncTabByStatus();fetchList()">
            <el-option label="待审核" value="待审核"></el-option>
            <el-option label="已通过" value="已通过"></el-option>
            <el-option label="已拒绝" value="已拒绝"></el-option>
            <el-option label="已过期" value="已过期"></el-option>
          </el-select>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">创建人</label>
          <el-input v-model="search.createUser" placeholder="请输入创建人" clearable size="small" style="width:120px;"></el-input>
        </div>
        <div class="form-group" style="margin:0;">
          <label style="font-size:12px;">展示时间</label>
          <div style="display:flex;align-items:center;gap:6px;">
            <el-date-picker v-model="search.startTimeBegin" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" size="small" style="width:130px;"></el-date-picker>
            <span style="color:var(--text-muted);">至</span>
            <el-date-picker v-model="search.startTimeEnd" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width:130px;"></el-date-picker>
          </div>
        </div>
        <div style="display:flex;gap:8px;">
          <el-button size="small" @click="resetFilter()">重置</el-button>
          <el-button type="primary" size="small" @click="fetchList()">🔍 搜索</el-button>
        </div>
      </div>
    </div>

    <!-- 状态 Tabs + 广告列表 -->
    <div style="display:flex;gap:0;border-bottom:1px solid #eef0f3;margin:0 0 12px;padding:0 2px;">
      <button v-for="tab in AD_STATUS_TABS" :key="tab.key" class="tab-btn" :class="{active:activeTab===tab.key}" @click="switchStatusTab(tab.key)">
        {{ tab.label }} <span v-if="stats[tab.countKey]" style="color:var(--text-muted);font-size:12px;">({{ stats[tab.countKey] }})</span>
      </button>
    </div>

    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">广告列表（共 {{ total }} 条）</span>
        <div style="display:flex;gap:8px;">
          <el-button v-auth="'business:adConfig:save'" type="primary" size="small" @click="openAddModal()">+ 新增广告</el-button>
          <el-button v-auth="'business:adConfig:review'" type="primary" size="small" @click="batchApprove()">✓ 审核</el-button>
          <el-button v-auth="'business:adConfig:review'" type="danger" size="small" @click="batchReject()">✕ 拒绝</el-button>
        </div>
      </div>
      <el-table :data="tableData" border size="small" style="font-size:13px;" v-loading="loading" @selection-change="selection=$event" :header-cell-style="{background:'#fafafa'}">
        <el-table-column type="selection" width="40" align="center"></el-table-column>
      <!--    <el-table-column label="排序" width="70" align="center">
          <template slot-scope="scope">
            <el-input-number :value="scope.row.sort" :controls="false" size="mini" min="0" style="width:52px;" @change="(v)=>updateSort(scope.row, v)"></el-input-number>
          </template>
        </el-table-column> -->
        <el-table-column prop="adNo" label="广告ID" width="100" align="center">
          <template slot-scope="scope"><span class="mono" style="color:var(--brand-primary);font-weight:500;">{{ scope.row.adNo }}</span></template>
        </el-table-column>
        <el-table-column label="语言" width="90">
          <template slot-scope="scope">{{ langLabel(scope.row.lang) }}</template>
        </el-table-column>
        <el-table-column prop="name" label="广告名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="typeName" label="广告类型" width="100"></el-table-column>
        <el-table-column label="广告页面" width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ (scope.row.positionNames || scope.row.positions || []).join('、') }}</template>
        </el-table-column>
        <el-table-column label="广告位置" width="90">
          <template slot-scope="scope">{{ scope.row.adSlotName || '--' }}</template>
        </el-table-column>
        <el-table-column label="广告对象" width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ describeAdTarget(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="显示平台" width="120">
          <template slot-scope="scope">{{ platformText(scope.row.platforms) }}</template>
        </el-table-column>
        <el-table-column label="开始时间" width="150">
          <template slot-scope="scope"><span :style="{color:timeColor(scope.row)}">{{ scope.row.startTime }}</span></template>
        </el-table-column>
        <el-table-column label="结束时间" width="150">
          <template slot-scope="scope"><span :style="{color:timeColor(scope.row)}">{{ scope.row.endTime }}</span></template>
        </el-table-column>
        <el-table-column label="审核状态" width="90">
          <template slot-scope="scope"><span class="status-badge" :style="statusBadgeStyle(scope.row.statusName)">{{ scope.row.statusName }}</span></template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" width="90"></el-table-column>
        <el-table-column label="审核人" width="90">
          <template slot-scope="scope">{{ scope.row.reviewedBy || '--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="150">
          <template slot-scope="scope">{{ scope.row.createDate || '--' }}</template>
        </el-table-column>
        <el-table-column label="审核时间" width="150">
          <template slot-scope="scope">{{ scope.row.reviewedAt || '--' }}</template>
        </el-table-column>
        <el-table-column label="备注" width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.rejectReason || '--' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button v-auth="'business:adConfig:review'" type="text" size="small" :disabled="['已通过','已拒绝','已过期'].indexOf(scope.row.statusName) >= 0" style="padding:0 4px;" @click="openReviewModal(scope.row)">审核</el-button>
            <el-button v-auth="'business:adConfig:edit'" type="text" size="small" style="padding:0 4px;" @click="openEditModal(scope.row)">编辑</el-button>
            <el-dropdown trigger="click" size="small" @command="(cmd)=>onRowCommand(cmd, scope.row)">
              <span class="el-dropdown-link" style="cursor:pointer;font-size:12px;color:var(--brand-primary);">更多 ▾</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-auth="'business:adConfig:copy'" command="copy">复制</el-dropdown-item>
                <el-dropdown-item v-auth="'business:adConfig:delete'" command="delete" style="color:#ff4d4f;">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-bar">
        <el-pagination
          @size-change="(v)=>{pageSize=v;pageNum=1;fetchList()}"
          @current-change="(v)=>{pageNum=v;fetchList()}"
          :current-page="pageNum"
          :page-sizes="[10,15,20,50]"
          :page-size="pageSize"
          layout="total,sizes,prev,pager,next"
          background
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑广告弹窗 -->
    <el-dialog :title="editTitle" :visible.sync="editVisible" width="760px" :close-on-click-modal="false">
      <div class="modal-body" style="max-height:65vh;overflow-y:auto;padding-right:8px;">

        <!-- 基础信息 -->
        <div style="margin-bottom:20px;">
          <div class="modal-section-title">基础信息</div>
          <div style="display:flex;gap:16px;">
            <div class="form-group" style="flex:1;">
              <label>语言 <span style="color:#ff4d4f;">*</span></label>
              <el-select v-model="editForm.lang" size="small" style="width:100%;" :disabled="isEdit">
                <el-option label="简体中文" value="zh_CN"></el-option>
                <el-option label="繁体中文" value="zh_TW"></el-option>
                <el-option label="English" value="en_US"></el-option>
              </el-select>
            </div>
            <div class="form-group" style="flex:1;">
              <label>广告名称 <span style="color:#ff4d4f;">*</span></label>
              <el-input v-model="editForm.name" size="small" placeholder="请输入广告名称"></el-input>
            </div>
            <div class="form-group" style="flex:1;">
              <label>广告类型 <span style="color:#ff4d4f;">*</span></label>
              <el-select v-model="editForm.type" size="small" style="width:100%;" :disabled="isEdit" placeholder="请选择" @change="onTypeChange()">
                <el-option v-for="t in AD_TYPE_OPTIONS" :key="t.value" :label="t.label" :value="t.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group" style="margin-top:12px;">
            <label>显示平台 <span style="color:#ff4d4f;">*</span></label>
            <el-checkbox-group v-model="editForm.platforms" style="display:flex;gap:12px;align-items:center;padding-top:8px;">
              <el-checkbox v-for="p in AD_PLATFORMS" :key="p.value" :label="p.value">{{ p.label }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>

        <!-- 投放页面/位置 -->
        <div style="margin-bottom:20px;">
          <div class="modal-section-title">投放页面/位置</div>
          <div class="form-group">
            <label>广告页面 <span style="color:#ff4d4f;">*</span> <span style="font-size:12px;color:var(--text-muted);font-weight:normal;">（可多选，同一位置仅展示排序最靠前的一条广告）</span></label>
            <el-select v-model="editForm.positions" multiple filterable size="small" placeholder="请选择广告页面" style="width:100%;">
              <el-option v-for="p in positionOptions" :key="p.code" :label="p.label" :value="p.code"></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label>广告位置</label>
            <el-select v-model="editForm.adSlot" clearable size="small" placeholder="请选择" style="width:200px;">
              <el-option v-for="s in AD_SLOTS" :key="s.value" :label="s.label" :value="s.value"></el-option>
            </el-select>
          </div>
      <!--    <div class="form-group">
            <label>排序权重</label>
            <el-input-number v-model="editForm.sort" :min="0" :controls="false" size="small" style="width:200px;"></el-input-number>
            <span style="font-size:12px;color:var(--text-muted);margin-left:8px;">数值越小越靠前</span>
          </div> -->
        </div>

        <!-- 广告对象 -->
        <div style="margin-bottom:20px;">
          <div class="modal-section-title">广告对象 <span style="font-size:12px;color:var(--text-muted);font-weight:normal;">（不选对象类型表示不限该维度）</span></div>
          <!-- 登录前页面（启动页/登陆/注册/注册第二页/注册成功页）没有客户身份，选了定向也投不出来，故禁用 -->
          <div v-if="targetForbidden" style="margin-top:10px;font-size:12px;color:#fa8c16;">
            「{{ preLoginPositionLabels }}」是登录前页面，没有客户身份可匹配，广告对象固定为「不限」
          </div>
          <div style="display:flex;gap:16px;flex-wrap:wrap;margin-top:12px;align-items:flex-start;">
            <div class="form-group" style="flex:0 0 200px;">
              <label>对象类型</label>
              <el-select v-model="editForm.targetType" size="small" style="width:100%;" placeholder="不限" clearable :disabled="targetForbidden" @change="onTargetTypeChange()">
                <el-option v-for="t in AD_TARGET_TYPES" :key="t.value" :label="t.label" :value="t.value"></el-option>
              </el-select>
            </div>
            <div class="form-group" style="flex:1;min-width:280px;">
              <label>对象值</label>
              <el-select v-if="editForm.targetType" v-model="editForm.targetValues" multiple filterable size="small" placeholder="请选择" style="width:100%;" :disabled="targetOptionsLoading || targetForbidden">
                <el-option v-for="o in targetValueOptions" :key="o.value" :label="o.label" :value="o.value"></el-option>
              </el-select>
              <span v-else style="font-size:12px;color:var(--text-muted);">{{ targetForbidden ? '登录前页面不支持配置广告对象，按「不限」投放' : '请先选择对象类型' }}</span>
            </div>
          </div>
        </div>

        <!-- 展示时间 -->
        <div style="margin-bottom:20px;">
          <div class="modal-section-title">展示时间</div>
          <div style="display:flex;gap:16px;">
            <div class="form-group" style="flex:1;">
              <label>开始时间 <span style="color:#ff4d4f;">*</span></label>
              <el-date-picker v-model="editForm.startTime" type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width:100%;"></el-date-picker>
            </div>
            <div class="form-group" style="flex:1;">
              <label>结束时间 <span style="color:#ff4d4f;">*</span></label>
              <!-- default-time：只选日期时时刻默认落在当天最后一秒（2026-09-22 → 2026-09-22 23:59:59），
                   避免结束时间被记成选中当天的 00:00:00 而少覆盖一整天 -->
              <el-date-picker v-model="editForm.endTime" type="datetime" default-time="23:59:59" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width:100%;"></el-date-picker>
            </div>
          </div>
        </div>

        <!-- 素材上传 -->
        <div style="margin-bottom:8px;">
          <div class="modal-section-title">素材上传</div>
          <div v-if="!editForm.type" style="padding:6px 0;font-size:12px;color:var(--text-muted);">请先选择广告类型</div>

          <!-- 多素材型：Banner轮播 / 跑马灯 -->
          <div v-else-if="AD_MULTI_TYPES.indexOf(curTypeName) >= 0">
            <div v-for="(m, idx) in editForm.materialList" :key="m._key" class="material-row">
              <div class="material-row-header">
                <span style="font-size:12px;font-weight:600;color:var(--text-secondary);">素材 {{ idx + 1 }}</span>
                <span style="display:flex;gap:4px;">
                  <el-button size="mini" :disabled="idx===0" @click="moveMaterial(idx, -1)">上移</el-button>
                  <el-button size="mini" :disabled="idx===editForm.materialList.length-1" @click="moveMaterial(idx, 1)">下移</el-button>
                  <el-button size="mini" type="danger" plain @click="removeMaterial(idx)">删除</el-button>
                </span>
              </div>
              <div v-if="curTypeName==='Banner轮播'" class="form-group">
                <label>图片/视频文件 <span style="color:#ff4d4f;">*</span> <span style="color:var(--text-muted);font-weight:normal;">（jpg/png/gif/mp4，图片≤5MB/张，视频≤50MB/个）</span></label>
                <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
                  <el-upload action="#" :show-file-list="false" accept="image/jpeg,image/png,image/gif,video/mp4" :before-upload="beforeMaterialUpload" :http-request="(opt)=>doUploadMaterial(m, opt.file)">
                    <el-button v-auth="'business:adConfig:upload'" size="small">选择图片/视频</el-button>
                  </el-upload>
                  <el-input v-model="m.fileUrl" size="small" placeholder="或直接输入图片/视频URL" style="flex:1;min-width:220px;"></el-input>
                </div>
                <div v-if="m.fileName" style="margin-top:6px;font-size:12px;color:var(--text-secondary);">已上传：{{ m.fileName }}</div>
              </div>
              <div v-else-if="curTypeName==='跑马灯'" class="form-group">
                <label>文案内容 <span style="color:#ff4d4f;">*</span> <span style="color:var(--text-muted);font-weight:normal;">（≤50字）</span></label>
                <el-input v-model="m.content" type="textarea" :rows="2" maxlength="50" size="small" placeholder="请输入滚动文案"></el-input>
              </div>
              <div style="display:flex;gap:16px;flex-wrap:wrap;">
                <div class="form-group" style="min-width:130px;">
                  <label>跳转类型</label>
                  <el-select v-model="m.linkType" size="small" style="width:100%;" @change="onMaterialLinkTypeChange(m)">
                    <el-option v-for="(lab, code) in AD_LINK_TYPE_MAP" :key="code" :label="lab" :value="Number(code)"></el-option>
                  </el-select>
                </div>
                <div class="form-group" v-if="m.linkType !== 4" style="flex:1;min-width:220px;">
                  <label>跳转目标 <span style="color:#ff4d4f;">*</span></label>
                  <el-select v-if="m.linkType === 3" v-model="m.linkTarget" filterable size="small" placeholder="请选择页面" style="width:100%;">
                    <el-option v-for="p in AD_PRESET_PAGES" :key="p.value" :label="p.label" :value="p.value"></el-option>
                  </el-select>
                  <el-input v-else v-model="m.linkTarget" size="small" placeholder="请输入外部链接URL"></el-input>
                </div>
              </div>
            </div>
            <div style="margin-top:6px;">
              <el-button type="primary" size="small" @click="addMaterial()">+ 添加一条素材</el-button>
            </div>
            <div v-if="curTypeName==='跑马灯'" style="display:flex;gap:16px;flex-wrap:wrap;align-items:flex-end;margin-top:10px;">
              <div class="form-group" style="min-width:160px;margin:0;">
                <label>滚动方式</label>
                <el-select v-model="editForm.scrollDir" size="small" style="width:100%;">
                  <el-option label="水平" :value="1"></el-option>
                  <el-option label="上下" :value="2"></el-option>
                </el-select>
              </div>
              <div class="form-group" style="min-width:160px;margin:0;">
                <label>滚动间隔时间</label>
                <el-input-number v-model="editForm.scrollInterval" :min="1" :controls="false" size="small" style="width:90px;"></el-input-number>
                <span style="font-size:12px;color:var(--text-muted);margin-left:4px;">秒</span>
              </div>
            </div>
            <div v-if="curTypeName==='Banner轮播'" style="display:flex;gap:16px;align-items:flex-end;margin-top:10px;">
              <div class="form-group" style="min-width:160px;margin:0;">
                <label>轮播间隔时间</label>
                <el-input-number v-model="editForm.carouselInterval" :min="1" :controls="false" size="small" style="width:90px;"></el-input-number>
                <span style="font-size:12px;color:var(--text-muted);margin-left:4px;">秒</span>
              </div>
            </div>
          </div>

          <!-- 单素材型：开屏 / 插屏 / 浮窗 -->
          <div v-else>
            <div class="form-group">
              <label>{{ singleMaterialFileLabel }} <span style="color:#ff4d4f;">*</span> <span style="color:var(--text-muted);font-weight:normal;">{{ singleMaterialHint }}</span></label>
              <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
                <el-upload action="#" :show-file-list="false" :accept="singleMaterialAccept" :before-upload="beforeMaterialUpload" :http-request="(opt)=>doUploadMaterial(singleMaterial, opt.file)">
                  <el-button v-auth="'business:adConfig:upload'" size="small">选择文件</el-button>
                </el-upload>
                <el-input v-model="singleMaterial.fileUrl" size="small" placeholder="或直接输入文件URL" style="flex:1;min-width:220px;"></el-input>
              </div>
              <div v-if="singleMaterial.fileName" style="margin-top:8px;font-size:12px;color:var(--text-secondary);">📎 已上传：{{ singleMaterial.fileName }}</div>
            </div>
            <div style="display:flex;gap:16px;flex-wrap:wrap;margin-top:10px;">
              <div class="form-group" style="min-width:130px;">
                <label>跳转类型</label>
                <el-select v-model="singleMaterial.linkType" size="small" style="width:100%;" @change="onMaterialLinkTypeChange(singleMaterial)">
                  <el-option v-for="(lab, code) in AD_LINK_TYPE_MAP" :key="code" :label="lab" :value="Number(code)"></el-option>
                </el-select>
              </div>
              <div class="form-group" v-if="singleMaterial.linkType !== 4" style="flex:1;min-width:220px;">
                <label>跳转目标 <span style="color:#ff4d4f;">*</span></label>
                <el-select v-if="singleMaterial.linkType === 3" v-model="singleMaterial.linkTarget" filterable size="small" placeholder="请选择页面" style="width:100%;">
                  <el-option v-for="p in AD_PRESET_PAGES" :key="p.value" :label="p.label" :value="p.value"></el-option>
                </el-select>
                <el-input v-else v-model="singleMaterial.linkTarget" size="small" placeholder="请输入外部链接URL"></el-input>
              </div>
            </div>
            <div v-if="curTypeName==='浮窗广告'" class="form-group" style="margin-top:10px;">
              <label>悬浮位置</label>
              <el-select v-model="singleMaterial.floatPos" size="small" style="width:160px;">
                <el-option v-for="(lab, code) in AD_FLOAT_POS_MAP" :key="code" :label="lab" :value="Number(code)"></el-option>
              </el-select>
            </div>
            <div v-if="curTypeName==='开屏广告' || curTypeName==='插屏广告'" class="form-group" style="margin-top:10px;">
              <label>展示/跳过倒计时（秒）<span style="color:var(--text-muted);font-weight:normal;">（可选）</span></label>
              <el-input-number v-model="singleMaterial.materialSeconds" :min="1" :max="15" :controls="false" size="small" style="width:160px;"></el-input-number>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="editVisible=false">取消</el-button>
        <el-button type="primary" @click="saveEdit()">保存</el-button>
      </div>
    </el-dialog>

    <!-- 广告审核弹窗 -->
    <el-dialog title="广告审核" :visible.sync="reviewVisible" width="480px" :close-on-click-modal="false">
      <div style="background:#fafafa;border-radius:8px;padding:12px;margin-bottom:16px;">
        <div style="display:flex;gap:16px;margin-bottom:8px;">
          <span style="font-size:12px;color:var(--text-muted);min-width:70px;">广告ID</span>
          <span class="mono" style="font-size:12px;">{{ reviewInfo.adNo }}</span>
        </div>
        <div style="display:flex;gap:16px;margin-bottom:8px;">
          <span style="font-size:12px;color:var(--text-muted);min-width:70px;">广告名称</span>
          <span style="font-size:12px;font-weight:500;">{{ reviewInfo.name }}</span>
        </div>
        <div style="display:flex;gap:16px;margin-bottom:8px;">
          <span style="font-size:12px;color:var(--text-muted);min-width:70px;">创建人</span>
          <span style="font-size:12px;">{{ reviewInfo.createUser }}</span>
        </div>
        <div style="display:flex;gap:16px;">
          <span style="font-size:12px;color:var(--text-muted);min-width:70px;">创建时间</span>
          <span style="font-size:12px;">{{ reviewInfo.createDate }}</span>
        </div>
      </div>
      <div class="form-group">
        <label>审核结果 <span style="color:#ff4d4f;">*</span></label>
        <el-radio-group v-model="reviewForm.reviewResult">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="3">拒绝</el-radio>
        </el-radio-group>
      </div>
      <div class="form-group" v-if="reviewForm.reviewResult === 3">
        <label>驳回原因 <span style="color:#ff4d4f;">*</span></label>
        <el-input v-model="reviewForm.rejectReason" type="textarea" :rows="3" size="small" placeholder="请输入驳回原因"></el-input>
      </div>
      <div slot="footer">
        <el-button @click="reviewVisible=false">取消</el-button>
        <el-button v-auth="'business:adConfig:review'" type="primary" @click="submitReview()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adConfigList, adConfigStats, adConfigDetail, adConfigSave, adConfigDelete, adConfigReview, adConfigBatchReview, adConfigCopy, adConfigSort, adConfigUpload } from '@/api/adConfig'
import { customerGroupList } from '@/api/customerGroup'
import { tradeGroupList } from '@/api/tradeGroup'
import { tagListAll } from '@/api/tagManagement'

// 广告页面以数字编码存储（与 AdPositionEnum 一致），code 为编码、label 为中文
const AD_POSITIONS = [
  { code: '1', label: '启动页' },
  { code: '2', label: '登陆' },
  { code: '3', label: '注册' },
  { code: '4', label: '注册第二页' },
  { code: '5', label: '注册成功页' },
  { code: '6', label: '账户管理' },
  { code: '7', label: '首页' },
  { code: '8', label: '行情' },
  { code: '9', label: '行情-自选' },
  { code: '10', label: '行情-行情' },
  { code: '11', label: '图表' },
  { code: '12', label: '图表-订单' },
  { code: '13', label: '图表-行情' },
  { code: '14', label: '交易' },
  { code: '15', label: '出金' },
  { code: '16', label: '入金' },
  { code: '17', label: '我的' },
  { code: '18', label: '活动' }
]
// 登录前页面：启动页(1)/登陆(2)/注册(3)/注册第二页(4)/注册成功页(5)。
// 这些页面还没登录、拿不到客户身份，配了广告对象也匹配不到（后端游客链路只收「交易组定向命中该游客组」
// 和「不限」两类，其余定向一律不进候选），所以选中其中任意一个时禁用广告对象，按「不限」投放
const PRE_LOGIN_POSITION_CODES = ['1', '2', '3', '4', '5']
// 广告位置（页内槽位，单选，与 AdSlotEnum 一致）：与「广告页面」是两个维度
// —— 广告页面决定投在哪一屏，广告位置决定投在该屏的哪个槽位
const AD_SLOTS = [
  { value: 'top', label: '顶部' },
  { value: 'center', label: '中部' },
  { value: 'bottom', label: '底部' }
]
// 平台显示为 iOS（与原型一致），存储/筛选值保持 IOS（与数据库一致）
const AD_PLATFORMS = [{ label: 'IOS', value: 'IOS' }, { label: 'Android', value: 'Android' }, { label: 'H5', value: 'H5' }, { label: 'PCUI', value: 'PCUI' }]
const AD_MULTI_TYPES = ['跑马灯','Banner轮播']
// 各广告类型可选位置：value 为位置编码（白名单，只判归属；
// 「广告页面」下拉的实际显示顺序由上面的 AD_POSITIONS 顺序决定，本数组顺序不影响展示）
const AD_POSITION_BY_TYPE = {
  // '3'(注册) 是按产品要求对 Banner轮播 额外开放的：原型 Banner轮播 只有 '5'(注册成功页)，
  // 没有 '3'(注册) 和 '4'(注册第二页)。别照着原型把 '3' 删掉；'4' 本次未开放
  'Banner轮播': ['7','8','9','10','11','12','13','14','3','5','16','15','17','18'],
  '跑马灯': ['7','14','8','17','18'],
  '开屏广告': ['1'],
  '插屏广告': ['5','16','15','7','8','14','18'],
  '浮窗广告': ['7','18','14','11','13','9','10','17','6']
}
const AD_PRESET_PAGES = [
  { value: 'app://home', label: '首页' },
  { value: 'app://market', label: '行情' },
  { value: 'app://trade', label: '交易' },
  { value: 'app://account', label: '账户管理' },
  { value: 'app://bonus', label: '活动中心' },
  { value: 'app://deposit', label: '入金' },
  { value: 'app://withdraw', label: '出金' },
  { value: 'app://customer-service', label: '在线客服' }
]
const AD_TARGET_TYPES = [
  { value: 'customerGroup', label: '客户组' },
  { value: 'tradeGroup', label: '交易账户组' },
  { value: 'tag', label: '标签' },
  { value: 'level', label: '会员等级' }
]
const AD_TARGET_TYPE_LABELS = { customerGroup: '客户组', tradeGroup: '交易账户组', tag: '标签', level: '会员等级' }
const AD_TYPE_OPTIONS = [
  { value: 1, label: 'Banner轮播' },
  { value: 2, label: '跑马灯' },
  { value: 3, label: '插屏广告' },
  { value: 4, label: '开屏广告' },
  { value: 5, label: '浮窗广告' }
]
const AD_LANG_LABELS = { zh_CN: '简体中文', zh_TW: '繁体中文', en_US: 'English' }
const AD_LINK_TYPE_MAP = { 1: '外部链接-新窗口', 2: '外部链接-内部跳转', 3: 'App内部页面', 4: '不跳转' }
const AD_FLOAT_POS_MAP = { 1: '右下', 2: '左下', 3: '右上', 4: '左上' }
const AD_STATUS_TABS = [
  { key: 'all', label: '全部', countKey: 'total' },
  { key: '待审核', label: '待审核', countKey: 'pending' },
  { key: '已通过', label: '已通过', countKey: 'passed' },
  { key: '已拒绝', label: '已拒绝', countKey: 'rejected' },
  { key: '已过期', label: '已过期', countKey: 'expired' }
]
// 会员等级：原型中为演示数据，真实等级管理接口尚未建立，暂用固定等级列表（后续接入后可替换为接口数据源）
const AD_LEVELS = ['LV1', 'LV2', 'LV3', 'LV4', 'LV5', 'LV6']

const STATUS_BADGE = {
  '待审核': { background: '#fff7e6', color: '#fa8c16' },
  '已通过': { background: '#e6f7e6', color: '#237804' },
  '已拒绝': { background: '#fff1f0', color: '#cf1322' },
  '已过期': { background: '#f5f5f5', color: '#8c8c8c' },
  '已下线': { background: '#f5f5f5', color: '#8c8c8c' }
}

export default {
  name: 'AdConfig',
  data() {
    return {
      AD_PLATFORMS,
      AD_POSITIONS,
      AD_SLOTS,
      AD_MULTI_TYPES,
      AD_PRESET_PAGES,
      AD_TARGET_TYPES,
      AD_TYPE_OPTIONS,
      AD_LINK_TYPE_MAP,
      AD_FLOAT_POS_MAP,
      AD_STATUS_TABS,
      search: { name: '', lang: '', type: null, platform: '', position: '', targetType: '', status: '', createUser: '', startTimeBegin: null, startTimeEnd: null },
      activeTab: 'all',
      stats: { total: 0, pending: 0, passed: 0, rejected: 0, expired: 0, offline: 0 },
      tableData: [], total: 0, pageNum: 1, pageSize: 15, loading: false, selection: [],
      editVisible: false, editTitle: '新增广告', isEdit: false,
      editForm: this.createEmptyForm(),
      targetOptions: { customerGroup: [], tradeGroup: [], tag: [], level: [] },
      targetOptionsLoading: false,
      reviewVisible: false, reviewInfo: {}, reviewForm: { id: null, reviewResult: 2, rejectReason: '' }
    }
  },
  computed: {
    // editForm.type 为数字编码(1-5)，此处映射为类型名称，供模板/方法按类型分支判断
    curTypeName() {
      const t = AD_TYPE_OPTIONS.find(o => o.value === this.editForm.type)
      return t ? t.label : ''
    },
    positionOptions() {
      const name = this.curTypeName
      const codes = (name && AD_POSITION_BY_TYPE[name]) ? AD_POSITION_BY_TYPE[name] : AD_POSITIONS.map(p => p.code)
      return AD_POSITIONS.filter(p => codes.indexOf(p.code) >= 0)
    },
    // 是否选到了登录前页面（启动页/登陆/注册/注册第二页/注册成功页）—— 选到就不允许配广告对象
    targetForbidden() {
      const positions = this.editForm.positions || []
      return PRE_LOGIN_POSITION_CODES.some(code => positions.indexOf(code) >= 0)
    },
    // 命中的登录前页面名称，用于提示文案
    preLoginPositionLabels() {
      const positions = this.editForm.positions || []
      return AD_POSITIONS
        .filter(p => PRE_LOGIN_POSITION_CODES.indexOf(p.code) >= 0 && positions.indexOf(p.code) >= 0)
        .map(p => p.label)
        .join('、')
    },
    targetValueOptions() {
      const type = this.editForm.targetType
      if (type === 'customerGroup') return this.targetOptions.customerGroup.map(g => ({ value: String(g.id), label: g.groupName }))
      if (type === 'tradeGroup') return this.targetOptions.tradeGroup.map(g => ({ value: String(g.id), label: g.groupName }))
      if (type === 'tag') return this.targetOptions.tag.map(t => ({ value: String(t.id), label: t.tagName }))
      if (type === 'level') return AD_LEVELS.map(v => ({ value: v, label: v }))
      return []
    },
    singleMaterial() {
      return this.editForm.materialList[0] || {}
    },
    singleMaterialFileLabel() {
      const type = this.curTypeName
      if (type === '开屏广告' || type === '插屏广告') return '图片/视频文件'
      if (type === '浮窗广告') return '图片文件'
      return '素材文件'
    },
    singleMaterialHint() {
      const type = this.curTypeName
      if (type === '开屏广告' || type === '插屏广告') return '（jpg/png/gif/mp4，图片≤5MB/张，视频≤50MB/个）'
      if (type === '浮窗广告') return '（jpg/png/gif，≤2MB）'
      return ''
    },
    singleMaterialAccept() {
      const type = this.curTypeName
      if (type === '开屏广告' || type === '插屏广告') return 'image/jpeg,image/png,image/gif,video/mp4'
      if (type === '浮窗广告') return 'image/jpeg,image/png,image/gif'
      return 'image/*'
    }
  },
  watch: {
    // 广告页面切到登录前页面时清空广告对象 —— 这类页面配了定向也投不出来，留着只会存下一条
    // 「配了却永远不生效」的广告（广告 9 就是这么来的）。用 watch 而非在 el-select 上挂 @change：
    // 编辑回填（openEdit 里 this.editForm = form）同样要过这一遍，历史脏数据也能被顺手清掉
    'editForm.positions'() {
      if (!this.targetForbidden) {
        return
      }
      if (!this.editForm.targetType && !(this.editForm.targetValues || []).length) {
        return
      }
      this.editForm.targetType = ''
      this.editForm.targetValues = []
      this.$message.info('「' + this.preLoginPositionLabels + '」为登录前页面，不支持配置广告对象，已清空')
    }
  },
  mounted() {
    this.loadTargetOptions()
    this.fetchStats()
    this.fetchList()
  },
  methods: {
    createEmptyForm() {
      return {
        id: null, name: '', lang: 'zh_CN', type: '', platforms: [], positions: [], adSlot: '', sort: 0,
        targetType: '', targetValues: [], startTime: '', endTime: '',
        scrollDir: 1, scrollInterval: '', carouselInterval: '', materialList: []
      }
    },
    createMaterial() {
      return { _key: Date.now() + '_' + Math.random(), id: null, sort: 0, content: '', fileUrl: '', fileName: '', linkType: 1, linkTarget: '', materialSeconds: '', floatPos: 1 }
    },

    // ========== 数据加载 ==========
    loadTargetOptions() {
      customerGroupList({ pageNum: 1, pageSize: 1000 }).then(res => {
        if (res.code === 0) this.targetOptions.customerGroup = (res.result && res.result.list) || []
      })
      tradeGroupList({ pageNum: 1, pageSize: 1000 }).then(res => {
        if (res.code === 0) this.targetOptions.tradeGroup = (res.result && res.result.list) || []
      })
      tagListAll().then(res => {
        if (res.code === 0) this.targetOptions.tag = (res.result && res.result.length) ? res.result : []
      })
    },
    fetchList() {
      this.loading = true
      const data = { pageNum: this.pageNum, pageSize: this.pageSize, ...this.search }
      if (!data.type) delete data.type
      if (data.startTimeBegin) data.startTimeBegin = data.startTimeBegin + ' 00:00:00'
      if (data.startTimeEnd) data.startTimeEnd = data.startTimeEnd + ' 23:59:59'
      adConfigList(data).then(res => {
        if (res.code === 0) {
          this.tableData = (res.result && res.result.list) || []
          this.total = (res.result && res.result.total) || 0
        }
      }).finally(() => { this.loading = false })
    },
    fetchStats() {
      adConfigStats().then(res => {
        if (res.code === 0) this.stats = res.result || {}
      })
    },
    resetFilter() {
      this.search = { name: '', lang: '', type: null, platform: '', position: '', targetType: '', status: '', createUser: '', startTimeBegin: null, startTimeEnd: null }
      this.activeTab = 'all'
      this.pageNum = 1
      this.fetchList()
    },
    switchStatusTab(key) {
      this.activeTab = key
      this.search.status = key === 'all' ? '' : key
      this.pageNum = 1
      this.fetchList()
    },
    syncTabByStatus() {
      this.activeTab = this.search.status || 'all'
    },

    // ========== 展示辅助 ==========
    langLabel(lang) { return AD_LANG_LABELS[lang] || lang || '简体中文' },
    platformText(list) { return (list || []).map(p => p === 'IOS' ? 'IOS' : p).join('、') },
    timeColor(row) {
      const now = new Date()
      const end = new Date((row.endTime || '').replace(/-/g, '/'))
      const start = new Date((row.startTime || '').replace(/-/g, '/'))
      if (!isNaN(end.getTime()) && end < now) return '#8c8c8c'
      if (!isNaN(start.getTime()) && start > now) return '#007A6A'
      return '#237804'
    },
    statusBadgeStyle(name) {
      const s = STATUS_BADGE[name] || STATUS_BADGE['已下线']
      return { display: 'inline-block', padding: '2px 8px', borderRadius: '4px', background: s.background, color: s.color, fontSize: '12px' }
    },
    getTargetLabel(type, value) {
      const v = String(value)
      if (type === 'customerGroup') { const o = this.targetOptions.customerGroup.find(g => String(g.id) === v); return o ? o.groupName : v }
      if (type === 'tradeGroup') { const o = this.targetOptions.tradeGroup.find(g => String(g.id) === v); return o ? o.groupName : v }
      if (type === 'tag') { const o = this.targetOptions.tag.find(t => String(t.id) === v); return o ? o.tagName : v }
      return v
    },
    describeAdTarget(row) {
      if (!row.targetType || !row.targetValues || !row.targetValues.length) return '全部用户'
      const label = AD_TARGET_TYPE_LABELS[row.targetType] || '对象'
      const names = row.targetValues.map(v => this.getTargetLabel(row.targetType, v))
      if (names.length > 3) return label + ':' + names.slice(0, 3).join('、') + '等' + names.length + '项'
      return label + ':' + names.join('、')
    },

    // ========== 行操作 ==========
    updateSort(row, v) {
      if (v == null || isNaN(v) || v < 0) { this.$message.warning('请输入有效的排序数字'); this.fetchList(); return }
      row.sort = v
      adConfigSort(row.id, v).then(res => {
        if (res.code === 0) { this.$message.success('排序已更新'); this.fetchList() }
      }).catch(() => { this.fetchList() })
    },
    onRowCommand(cmd, row) {
      if (cmd === 'copy') this.copyAd(row)
      else if (cmd === 'delete') this.deleteAd(row)
    },
    copyAd(row) {
      this.$confirm('确定要复制该广告吗？复制后将进入待审核状态。', '提示', { type: 'warning' }).then(() => {
        adConfigCopy(row.id).then(res => {
          if (res.code === 0) { this.$message.success(res.result || '复制成功'); this.fetchList(); this.fetchStats() }
        })
      }).catch(() => {})
    },
    deleteAd(row) {
      this.$confirm('确定要删除该广告吗？', '提示', { type: 'warning' }).then(() => {
        adConfigDelete([row.id]).then(res => {
          if (res.code === 0) { this.$message.success('删除成功'); this.fetchList(); this.fetchStats() }
        })
      }).catch(() => {})
    },

    // ========== 批量审核 ==========
    batchApprove() { this.batchReview(2, '审核通过') },
    batchReject() { this.batchReview(3, '拒绝') },
    batchReview(result, actionLabel) {
      const pendingSel = this.selection.filter(r => r.statusName === '待审核')
      const ids = pendingSel.length ? pendingSel.map(r => r.id) : []
      const count = pendingSel.length || (this.stats.pending || 0)
      if (count === 0) { this.$message.warning('没有可审核的广告'); return }
      this.$confirm('确定' + actionLabel + ' ' + count + ' 条广告？', '批量审核确认', { type: 'warning' }).then(() => {
        const payload = { ids, reviewResult: result }
        if (result === 3) payload.rejectReason = '批量拒绝'
        adConfigBatchReview(payload).then(res => {
          if (res.code === 0) { this.$message.success(actionLabel + '成功'); this.fetchList(); this.fetchStats() }
        })
      }).catch(() => {})
    },

    // ========== 审核弹窗 ==========
    openReviewModal(row) {
      this.reviewInfo = { adNo: row.adNo, name: row.name, createUser: row.createUser, createDate: row.createDate }
      this.reviewForm = { id: row.id, reviewResult: 2, rejectReason: '' }
      this.reviewVisible = true
    },
    submitReview() {
      const rf = this.reviewForm
      if (rf.reviewResult === 3 && !(rf.rejectReason && rf.rejectReason.trim())) { this.$message.warning('请输入驳回原因'); return }
      adConfigReview(rf).then(res => {
        if (res.code === 0) {
          this.$message.success(rf.reviewResult === 2 ? '审核通过' : '已拒绝')
          this.reviewVisible = false
          this.fetchList(); this.fetchStats()
        }
      })
    },

    // ========== 新增/编辑弹窗 ==========
    openAddModal() {
      this.isEdit = false
      this.editTitle = '新增广告'
      this.editForm = this.createEmptyForm()
      this.editVisible = true
    },
    openEditModal(row) {
      this.isEdit = true
      this.editTitle = '编辑广告'
      adConfigDetail(row.id).then(res => {
        if (res.code === 0) {
          const d = res.result
          const form = this.createEmptyForm()
          form.id = d.id
          form.name = d.name
          form.lang = d.lang || 'zh_CN'
          form.type = d.type
          form.platforms = d.platforms || []
          form.positions = d.positions || []
          form.adSlot = d.adSlot || ''
          form.sort = d.sort || 0
          form.targetType = d.targetType || ''
          form.targetValues = (d.targetValues || []).map(v => String(v))
          form.startTime = d.startTime
          form.endTime = d.endTime
          form.scrollDir = d.scrollDir || 1
          form.scrollInterval = d.scrollInterval || ''
          form.carouselInterval = d.carouselInterval || ''
          form.materialList = (d.materialList && d.materialList.length)
            ? d.materialList.map(m => ({
                _key: Date.now() + '_' + Math.random(),
                id: m.id, sort: m.sort, content: m.content || '',
                fileUrl: m.fileUrl || '', fileName: m.fileUrl ? '已上传' : '',
                linkType: m.linkType || 1, linkTarget: m.linkTarget || '',
                materialSeconds: m.materialSeconds, floatPos: m.floatPos || 1
              }))
            : [this.createMaterial()]
          this.editForm = form
          this.editVisible = true
        }
      })
    },
    onTypeChange() {
      const allowed = this.positionOptions.map(p => p.code)
      this.editForm.positions = (this.editForm.positions || []).filter(p => allowed.indexOf(p) >= 0)
      const isMulti = AD_MULTI_TYPES.indexOf(this.curTypeName) >= 0
      if (this.editForm.type && isMulti && !this.editForm.materialList.length) {
        this.editForm.materialList = [this.createMaterial()]
      } else if (this.editForm.type && !isMulti) {
        if (this.editForm.materialList.length !== 1) {
          this.editForm.materialList = [this.createMaterial()]
        } else {
          this.editForm.materialList[0].content = ''
        }
      }
    },
    onTargetTypeChange() {
      this.editForm.targetValues = []
    },
    addMaterial() {
      this.editForm.materialList.push(this.createMaterial())
    },
    removeMaterial(idx) {
      this.editForm.materialList.splice(idx, 1)
    },
    moveMaterial(idx, dir) {
      const target = idx + dir
      if (target < 0 || target >= this.editForm.materialList.length) return
      const list = this.editForm.materialList
      const t = list[idx]
      list[idx] = list[target]
      list[target] = t
      this.editForm.materialList = [...list]
    },
    onMaterialLinkTypeChange(m) {
      if (m.linkType === 4) m.linkTarget = ''
    },
    validateMaterialFile(file) {
      const type = this.curTypeName
      let maxMB = 5, okTypes = null
      if (type === 'Banner轮播') { maxMB = 5; okTypes = ['image/jpeg', 'image/png', 'image/webp'] }
      else if (type === '浮窗广告') { maxMB = 2; okTypes = ['image/jpeg', 'image/png', 'image/gif'] }
      else if (type === '开屏广告' || type === '插屏广告') {
        if ((file.type || '').indexOf('video') >= 0) { maxMB = 20 }
        else { maxMB = 5; okTypes = ['image/jpeg', 'image/png', 'image/gif'] }
      }
      if (file.size > maxMB * 1024 * 1024) { this.$message.warning('文件大小超过' + maxMB + 'MB限制'); return false }
      if (okTypes && okTypes.indexOf(file.type) < 0) { this.$message.warning('文件格式不支持'); return false }
      return true
    },
    beforeMaterialUpload(file) {
      return this.validateMaterialFile(file)
    },
    doUploadMaterial(material, file) {
      if (!this.validateMaterialFile(file)) return
      // 全屏蒙层：上传期间挡住重复点击/误操作，避免同一素材并发上传互相覆盖 fileUrl
      const loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      adConfigUpload(file).then(res => {
        if (res.code === 0) {
          material.fileUrl = res.result
          material.fileName = file.name
          this.$message.success('上传成功')
        } else {
          this.$message.error(res.message || '上传失败')
        }
      }).catch(() => {
        this.$message.error('上传失败')
      }).finally(() => {
        // 成功/失败都必须关闭，否则失败时蒙层会一直挂着挡住整个页面
        loading.close()
      })
    },
    saveEdit() {
      const f = this.editForm
      if (!f.name || !f.name.trim()) { this.$message.warning('请输入广告名称'); return }
      if (!f.type) { this.$message.warning('请选择广告类型'); return }
      if (!f.platforms || !f.platforms.length) { this.$message.warning('请选择显示平台'); return }
      if (!f.positions || !f.positions.length) { this.$message.warning('请选择广告页面'); return }
      if (!f.startTime || !f.endTime) { this.$message.warning('请选择展示时间范围'); return }
      if (f.endTime <= f.startTime) { this.$message.warning('结束时间必须晚于开始时间'); return }

      const isMulti = AD_MULTI_TYPES.indexOf(this.curTypeName) >= 0
      if (isMulti) {
        if (!f.materialList.length) { this.$message.warning('请至少添加一条素材'); return }
        for (let i = 0; i < f.materialList.length; i++) {
          const m = f.materialList[i]
          if (this.curTypeName === 'Banner轮播' && !m.fileUrl) { this.$message.warning('素材' + (i + 1) + '请上传图片文件'); return }
          if (this.curTypeName === '跑马灯' && !(m.content && m.content.trim())) { this.$message.warning('素材' + (i + 1) + '请输入文案内容'); return }
          if (m.linkType !== 4 && !m.linkTarget) { this.$message.warning('素材' + (i + 1) + '请输入跳转目标'); return }
        }
      } else {
        const m = f.materialList[0]
        if (!m || !m.fileUrl) { this.$message.warning('请上传素材文件'); return }
        if (m.linkType !== 4 && !m.linkTarget) { this.$message.warning('请输入跳转目标'); return }
      }

      const data = {
        id: f.id, name: f.name.trim(), lang: f.lang, type: f.type,
        platforms: f.platforms, positions: f.positions, adSlot: f.adSlot || '', sort: f.sort || 0,
        targetType: f.targetType || '', targetValues: f.targetValues || [],
        startTime: f.startTime, endTime: f.endTime,
        scrollDir: f.scrollDir || 1,
        scrollInterval: parseInt(f.scrollInterval) || 0,
        carouselInterval: parseInt(f.carouselInterval) || 0,
        materialList: f.materialList.map((m, idx) => ({
          id: m.id || null, sort: idx, content: m.content || '', fileUrl: m.fileUrl || '',
          linkType: m.linkType || 1, linkTarget: m.linkTarget || '',
          materialSeconds: m.materialSeconds ? parseInt(m.materialSeconds) : null,
          floatPos: m.floatPos || null
        }))
      }
      adConfigSave(data).then(res => {
        if (res.code === 0) {
          this.$message.success(this.isEdit ? '广告已修改并提交审核' : '广告已创建并提交审核')
          this.editVisible = false
          this.fetchList(); this.fetchStats()
        }
      })
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; background: #f5f7fa; min-height: calc(100vh - 84px); }
.table-wrapper { background: #fff; border: 1px solid #e8ecf2; border-radius: 12px; overflow: hidden; }
.table-header { display: flex; align-items: center; justify-content: space-between; padding: 14px 20px; border-bottom: 1px solid #e8ecf2; }
.table-title { font-size: 14px; font-weight: 600; }
.pagination-bar { display: flex; align-items: center; justify-content: flex-end; padding: 14px 20px; border-top: 1px solid #e8ecf2; }
.tab-btn { padding: 10px 20px; font-size: 13px; font-weight: 500; cursor: pointer; border: none; background: none; color: #909399; border-bottom: 2px solid transparent; }
.tab-btn.active { color: var(--brand-primary); border-bottom-color: var(--brand-primary); }
.modal-section-title { font-size: 13px; font-weight: 600; color: #303133; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #ebeef5; }
.form-group { margin-bottom: 12px; }
.form-group label { display: block; font-size: 13px; color: #606266; margin-bottom: 6px; }
.material-row { border: 1px solid #ebeef5; border-radius: 8px; padding: 12px; margin-bottom: 10px; }
.material-row-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.mono { font-family: monospace; }
</style>
